const serverConstants = require('../../server/bot/cdc/constants');

module.exports = {
  ...serverConstants,
  theme: {
    palette: {
      primary: {
        main: '#11456C',
      },
      secondary: {
        main: '#f5f5f5',
      },
      background: {
        default: '#FFFFFF',
      },
    },
    overrides: {
      MuiOutlinedInput: {
        notchedOutline: {
          borderColor: 'rgba(25,25,25,.32)',
        },
      },
      // disable transtion to fix Select flickering issues on iOS 15.4
      // https://github.com/mui/material-ui/issues/32353
      // https://github.com/mui/material-ui/issues/31380
      MuiPaper: {
        root: {
          transition: 'none !important',
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          width: '100%',
        },
      },
    },
  },
};
